import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'

import ConfirmModal from '../../../../components/ConfirmModal'
import useLocalStorage from '../../../../hooks/useLocalStorage'
import API from '../../../../utils/api'
import './game-container.scss'

const OPEN_TRANSITION = {
  type: 'spring',
  damping: 34,
  stiffness: 420,
  mass: 0.82,
}

const CLOSE_TRANSITION = {
  duration: 0.26,
  ease: [0.4, 0, 0.2, 1],
}

export const GameContainer = ({ game, gameOpened, onGameClose, demo }) => {
  const iframeRef = useRef(null)
  const [showExitModal, setShowExitModal] = useState(false)
  const [isClosing, setIsClosing] = useState(false)
  const [sessionGameData, setSessionGameData] = useLocalStorage(
    'sessionGameData',
    {
      game_code: null,
      token_id: null,
      type: null,
      demo,
    }
  )

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })

    document.body.classList.add('casino-game-opened')

    return () => {
      document.body.classList.remove('casino-game-opened')
    }
  }, [gameOpened])

  useEffect(() => {
    if (demo !== undefined && demo === true) {
      API.launchDemoGame(game.id, false).then((response) => {
        const { success, url, error, game_code, token_id } = response.data

        if (success) {
          iframeRef.current.setAttribute('src', url)

          setSessionGameData({
            game_code,
            token_id,
            type: 'slots',
            demo: true,
          })
        } else {
          alert('Error: ' + error)
          onGameClose(sessionGameData)
        }
      })
    } else {
      API.launchGame(game.id, false).then((response) => {
        const { success, url, error, game_code, token_id } = response.data

        if (success) {
          iframeRef.current.setAttribute('src', url)

          setSessionGameData({
            game_code,
            token_id,
            type: 'slots',
            demo: false,
          })
        } else {
          alert('Error: ' + error)
          onGameClose(sessionGameData)
        }
      })
    }

    return () => {
      iframeRef.current.setAttribute('src', '')
      iframeRef.current = null
    }
  }, [demo, game.id])

  const hide = () => {
    setIsClosing(true)
  }

  const handlePanelAnimationComplete = () => {
    if (isClosing) {
      onGameClose(sessionGameData)
    }
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault()
      event.returnValue = ''
      onGameClose(sessionGameData)
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [sessionGameData])

  const hideRequest = () => {
    setShowExitModal(true)
  }

  return (
    <div className='game-container-root'>
      <motion.div
        className='game-container-backdrop'
        aria-hidden='true'
        initial={{ opacity: 0 }}
        animate={{ opacity: isClosing ? 0 : 1 }}
        transition={
          isClosing
            ? CLOSE_TRANSITION
            : { duration: 0.32, ease: [0, 0, 0.2, 1] }
        }
      />

      <motion.div
        className='game-container'
        role='dialog'
        aria-modal='true'
        aria-label={demo ? `${game.name} demo` : game.name}
        initial={{ opacity: 0, y: 5, scale: 0.96 }}
        animate={
          isClosing
            ? { opacity: 0, y: 5, scale: 0.99 }
            : { opacity: 1, y: 0, scale: 1 }
        }
        transition={isClosing ? CLOSE_TRANSITION : OPEN_TRANSITION}
        onAnimationComplete={handlePanelAnimationComplete}
      >
        <ConfirmModal
          onClose={() => setShowExitModal(false)}
          onConfirm={hide}
          show={showExitModal}
          message='¿Estas seguro que quieres salir del juego?'
        />
        <div className='game-container-header'>
          <div className='thumbnail-container'>
            <img src={game.thumbnail} alt={game.name} />
          </div>
          <h1>
            {game.name}
            {demo ? ' - DEMO' : null}
          </h1>
          <a className='btn-close' onClick={hideRequest}>
            <i className='icon ion-close' />
          </a>
        </div>
        <div className='game-container-body'>
          <iframe
            title={game.name}
            id='partner-iframe'
            width='100%'
            height='100%'
            frameBorder={0}
            ref={iframeRef}
            sandbox='allow-scripts allow-forms allow-same-origin allow-popups'
          />
        </div>
      </motion.div>
    </div>
  )
}
